module.exports = __webpack_public_path__ + "media/images/front/pc/treatment-introduction-article/img01-c70df19aa62a2fe201f6820919a2df3d.png";